import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

import { Mode, DeviceType } from '../../models/enums'

import VoiceInput from './VoiceInput'
import SendTextBox from './SendTextBox'

const UserRequest = (): JSX.Element => {
  const configuration = useSelector((state: RootState) => state.retorikReducer.configuration)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)
  const currentDeviceType = useSelector((state: RootState) => state.viewReducer.currentDeviceType)
  const mediumLandscape = useSelector((state: RootState) => state.viewReducer.mediumLandscape)
  const currentHeight = useSelector((state: RootState) => state.viewReducer.currentHeight)

  const [gridRowStart, setGridRowStart] = useState<number>()
  const [gridRowSpan, setGridRowSpan] = useState<number>()
  const [paddingTop, setPaddingTop] = useState<number>()
  const [paddingBottom, setPaddingBottom] = useState<number>()

  useEffect(() => {
    const remToPx = parseFloat(getComputedStyle(document.documentElement).fontSize)

    switch (currentDeviceType) {
      case DeviceType.landscape:
      case DeviceType.widgetLandscape: {
        if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.landscape?.containerRowEndText) {
          setGridRowStart(configuration.answerpanel.landscape.containerRowEndText)
          setGridRowSpan(13 - configuration.answerpanel.landscape.containerRowEndText)
        } else {
          setGridRowStart(10)
          setGridRowSpan(3)
        }

        setPaddingTop((currentHeight * 1) / 12 - 1.5 * remToPx)
        setPaddingBottom(remToPx)
        break
      }
      case DeviceType.borne:
      case DeviceType.widgetBorne: {
        if (typeof configuration?.answerpanel === 'object' && configuration.answerpanel.borne?.containerRowStart) {
          setGridRowStart(1)
          setGridRowSpan(configuration.answerpanel.borne.containerRowStart - 1)
        } else {
          setGridRowStart(4)
          setGridRowSpan(2)
        }

        setPaddingTop(remToPx * 1.25)
        setPaddingBottom(remToPx * 1.25)
        break
      }
    }
  }, [configuration.answerpanel, currentDeviceType, currentHeight])

  return (
    <div
      id='retorik-userRequest'
      className={`rf-relative rf-z-[3] rf-h-full rf-w-3/5 landscape-retorik:rf-w-[calc(80%-10rem)] landscape-retorik:rf-ml-1/5 rf-flex rf-flex-col rf-justify-self-center rf-justify-end landscape-retorik:rf-justify-self-start landscape-retorik:rf-justify-start
        ${mediumLandscape ? 'landscape-retorik:rf-col-start-3' : 'landscape-retorik:rf-col-start-4'} large-vertical:rf-col-start-1 rf-col-span-full rf-text-size-auto rf-text-trueblack`}
      style={{
        gridRow: `${gridRowStart} / span ${gridRowSpan}`,
        paddingTop: paddingTop,
        paddingBottom: paddingBottom
      }}
    >
      {mode === Mode.text ? <SendTextBox /> : <VoiceInput />}
    </div>
  )
}

export default UserRequest
